<script setup lang="ts">
import { inject } from 'vue'
import WizardTabWithSidebar from '../WizardTabWithSidebar.vue'
import WizardHeader from '../WizardHeader.vue'
import { ReceiptTaxIcon } from '@heroicons/vue/outline'
import BaseButtonPrimary from '../../base/BaseButtonPrimary.vue'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import { usePersonalAccountFormState } from '../../../utilities/account/useAccountFormPersonal'
import TinForm from './form/TinForm.vue'

const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')
const formState = usePersonalAccountFormState()

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        await formState.submit()
        navigateToNextTab()
    }
}
</script>

<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <div class="w-full space-y-4 py-4">
                <WizardHeader :title="$t('account_settings.tax_residencies')" :icon="ReceiptTaxIcon"></WizardHeader>

                <TinForm></TinForm>
            </div>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.natural_tax') }}
            </p>
        </template>

        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().loading"
                :disabled="usePersonalAccountDataState().loading || formState.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }} </BaseButtonMuted>
        </template>
    </WizardTabWithSidebar>
</template>

<style scoped></style>
